import { render } from "./AppointmentButton.vue?vue&type=template&id=8bb9e0f2"
import script from "./AppointmentButton.vue?vue&type=script&lang=js"
export * from "./AppointmentButton.vue?vue&type=script&lang=js"

import "./AppointmentButton.vue?vue&type=style&index=0&id=8bb9e0f2&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__